import { globalSingleton } from './chunk-N7SZ66QO.js';

// src/evidence/provider-ids.generated.json
var provider_ids_generated_default = {
  ids: [
    "across",
    "alchemy",
    "ankr",
    "antelope_rpc",
    "aptos_rest",
    "arkham",
    "blockchair",
    "blockchair_api",
    "blockscan",
    "blockscout",
    "blocksec",
    "blockstream",
    "bob_gateway",
    "chainflip",
    "chainlink_ccip",
    "codeslaw",
    "coingecko",
    "coingecko_web",
    "coinmarketcap",
    "cosmos_directory",
    "cosmos_lcd",
    "cowswap",
    "debridge_dln",
    "defillama",
    "dexscreener",
    "etherscan",
    "etherscan_family",
    "etherscan_scan",
    "evm_rpc",
    "fastnear",
    "fourbyte",
    "garden",
    "goldrush",
    "helius",
    "hop",
    "hyperlane",
    "hyperliquid",
    "infura",
    "layerzero",
    "mayachain",
    "mayan",
    "mempool_space",
    "metasleuth",
    "moralis",
    "moralis_explorer",
    "moralis_official",
    "near_intents",
    "near_rpc",
    "openchain_4byte",
    "polymarket_clob",
    "polymarket_data",
    "polymarket_gamma",
    "quicknode",
    "relay",
    "routescan",
    "scanscope",
    "solana_rpc",
    "solscan",
    "sourcify",
    "starknet_rpc",
    "sui_graphql",
    "tatum",
    "thegraph",
    "thorchain",
    "toncenter",
    "trongrid",
    "tronscan",
    "whatsabi",
    "wormhole",
    "xmrchain",
    "xrpl_rpc",
    "xrpscan",
    "zapper",
    "zerox_scope_legacy",
    "zksync_explorer"
  ],
  names: [
    "arkham intelligence",
    "arkhamintelligence",
    "zerox_scope_legacy",
    "cosmos_directory",
    "etherscan_family",
    "moralis_explorer",
    "moralis_official",
    "polymarket_gamma",
    "4byte.directory",
    "coin market cap",
    "openchain_4byte",
    "polymarket_clob",
    "polymarket_data",
    "zksync_explorer",
    "blockchair_api",
    "etherscan_scan",
    "coingecko_web",
    "coinmarketcap",
    "mempool_space",
    "antelope_rpc",
    "starknet_rpc",
    "blockdaemon",
    "blockstream",
    "dexscreener",
    "sui_graphql",
    "aptos_rest",
    "blockchair",
    "blockscout",
    "coin gecko",
    "cosmos_lcd",
    "metasleuth",
    "quick node",
    "solana_rpc",
    "blockscan",
    "chainbase",
    "coingecko",
    "defillama",
    "etherscan",
    "openchain",
    "quicknode",
    "routescan",
    "scanscope",
    "the graph",
    "toncenter",
    "0x scope",
    "bitquery",
    "blocksec",
    "codeslaw",
    "covalent",
    "fastnear",
    "fourbyte",
    "goldrush",
    "near_rpc",
    "nodereal",
    "sourcify",
    "tenderly",
    "thegraph",
    "trongrid",
    "tronscan",
    "whatsabi",
    "xmrchain",
    "xrpl_rpc",
    "0xscope",
    "alchemy",
    "evm_rpc",
    "moralis",
    "solscan",
    "xrpscan",
    "arkham",
    "helius",
    "infura",
    "nansen",
    "zapper",
    "tatum",
    "ankr"
  ],
  first_party: [
    "behavioural_heuristics",
    "bridges_registry",
    "bytecode",
    "catalog_import",
    "dust_campaign_detector",
    "erc4337_safe",
    "feedback",
    "forensic_account_type",
    "forensic_address_poisoning",
    "forensic_airdrop_farmer",
    "forensic_consolidation_wallet",
    "forensic_counterfeit_token",
    "forensic_deposit_address",
    "forensic_drainer",
    "forensic_ens_name",
    "forensic_exposure",
    "forensic_factory_instance",
    "forensic_funding_source",
    "forensic_pass_through",
    "forensic_protocol_usage",
    "forensic_scam_deployer",
    "forensic_spam_token",
    "forensic_trading_bot",
    "inferred",
    "internal",
    "manual",
    "operator_curated",
    "protocol_registry"
  ]
};

// src/evidence/privacy.ts
var DATA_SOURCE_LABEL = "Authe data";
var ids = new Set(provider_ids_generated_default.ids);
var firstParty = new Set(provider_ids_generated_default.first_party);
var names = provider_ids_generated_default.names;
var escape = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
var namePattern = new RegExp(`(?<![a-z0-9])(?:ProviderId\\.)?(?:${names.map(escape).join("|")})(?:[_-](?:explorer|official|web|api))?(?![a-z0-9])`, "gi");
var nameCheck = new RegExp(namePattern.source, "i");
var hasName = (s) => nameCheck.test(s);
var privacy = globalSingleton("evidence/privacy", () => ({ customerAudience: false }));
function enableCustomerDataPrivacy() {
  privacy.customerAudience = true;
}
function customerData(value) {
  return privacy.customerAudience ? redactCustomerData(value) : value;
}
function customerText(value) {
  return privacy.customerAudience ? privateSourceText(value) : value;
}
function privateSourceText(text) {
  return text.replace(/asserted by provider\s+([^\s(]+)/gi, (line, id) => firstParty.has(id) ? line : "attributed by Authe").replace(/https?:\/\/[^\s<>"')\]]+/gi, (url) => hasName(url) ? "data service" : url).replace(namePattern, DATA_SOURCE_LABEL);
}
function privateSourceLabel(value) {
  if (value == null || value === "") return void 0;
  const text = String(value);
  const id = text.toLowerCase().replace(/^provider:|^source_system=/, "");
  if (["whatsabi", "openchain", "openchain_4byte"].includes(id)) return id === "whatsabi" ? "bytecode_analysis" : "4byte";
  return ids.has(id) || hasName(text) || id === "aggregate" || id === "aggregated from multiple sources" ? DATA_SOURCE_LABEL : text;
}
var identity = /* @__PURE__ */ new Set(["provider", "provider_id", "providerId", "provider_name", "providerName", "upstream_provider", "vendor", "vendor_id"]);
var origins = /* @__PURE__ */ new Set(["source", "source_id", "sourceId", "source_name", "sourceLabel", "source_label", "data_source", "origin", "abi_source", "price_source", "upstream_source", "claimSource", "contributors"]);
var prose = /* @__PURE__ */ new Set(["explanation", "explain", "reasons", "reason", "message", "error", "error_message", "detail", "details", "warning", "warnings", "failure_reason", "last_error", "problems", "save_problems", "enabled_nodes", "disabled_nodes", "decision_summary", "decision_reason"]);
var privateRefs = /* @__PURE__ */ new Set(["raw_payload_ref", "provider_url", "provider_endpoint"]);
var sourceLinks = /* @__PURE__ */ new Set(["source_url", "sourceUrl"]);
function privateEvidenceSource(source) {
  if (!source) return false;
  if (source.visibility === "internal") return true;
  if (typeof source.id === "string" && firstParty.has(source.id)) return false;
  return source.kind === "provider" || typeof source.id === "string" && privateSourceLabel(source.id) !== source.id;
}
function redactCustomerData(value) {
  const visit = (item, key = "", parentPrivate = false) => {
    if (typeof item === "string") {
      if (identity.has(key)) return privateSourceLabel(item);
      if (origins.has(key) || key === "sources" || key === "providers" || /_(?:source|source_id|provider|provider_id)$/.test(key)) return privateSourceLabel(item);
      if (prose.has(key)) return privateSourceText(item);
      if (key === "description" && /\b(?:imported|sourced|fetched|provided|supplied|attributed|asserted)\b/i.test(item)) return privateSourceText(item);
      if (/^(?:logo|logo_url|logoUrl|logo_uri|logoUri|icon_url|iconUrl|icon_uri|iconUri|thumbnail|thumbnail_url|image_url|imageUrl)$/.test(key) && /^https?:\/\//i.test(item) && hasName(item)) return null;
      if (["payload", "metadata", "body", "evidence"].includes(key) && /^[\[{]/.test(item.trim())) {
        try {
          return JSON.stringify(visit(JSON.parse(item), key));
        } catch {
        }
      }
      return item;
    }
    if (Array.isArray(item)) return item.filter((v) => !(key === "origins" && typeof v?.path === "string" && v.path.startsWith("base_overrides.third_party."))).map((v) => visit(v, key, parentPrivate));
    if (!item || typeof item !== "object" || Object.getPrototypeOf(item) !== Object.prototype) return item;
    const row = item;
    if (row.kind === "url" && typeof row.value === "string" && hasName(row.value)) return null;
    const source = row.source && typeof row.source === "object" ? row.source : void 0;
    const hidden = ["source", "sources", "provider", "providers"].includes(key) && privateEvidenceSource(row);
    const evidencePrivate = privateEvidenceSource(source);
    const out = {};
    for (const [field, val] of Object.entries(row)) {
      if (["base_tables", "base_overrides"].includes(key) && field === "third_party" || field.startsWith("base_overrides.third_party.")) continue;
      if (field === "traceback") continue;
      if (field === "source" && "target" in row) {
        out[field] = val;
        continue;
      }
      if (sourceLinks.has(field) && (hidden || evidencePrivate || typeof val === "string" && hasName(val) || Object.entries(row).some(([k, v]) => (identity.has(k) || origins.has(k) && !(k === "source" && "target" in row)) && typeof v === "string" && privateSourceLabel(v) !== v))) continue;
      if (privateRefs.has(field) || (hidden || parentPrivate) && ["id", "name", "url", "external_id", "raw_payload"].includes(field)) continue;
      if (hidden && field === "kind") {
        out[field] = "aggregate";
        continue;
      }
      if (hidden && field === "visibility") {
        out[field] = "external";
        continue;
      }
      if ((evidencePrivate || hidden) && ["metadata", "signals", "context", "reasons"].includes(field)) {
        out[field] = field === "context" && val && typeof val === "object" ? Object.fromEntries(Object.entries(val).filter(([k]) => k === "scope" || k === "scope_tier")) : field === "reasons" ? [] : {};
        continue;
      }
      out[field] = visit(val, field, field === "source" && evidencePrivate);
    }
    return out;
  };
  return visit(value);
}

export { DATA_SOURCE_LABEL, customerData, customerText, enableCustomerDataPrivacy, privateSourceLabel, privateSourceText, redactCustomerData };
//# sourceMappingURL=chunk-EE3BFQYH.js.map
//# sourceMappingURL=chunk-EE3BFQYH.js.map